
export default {
  data() {
    return {
      categories: [],
    };
  },

  methods: {
    appendCategory(category) {
      this.categories = [];

      if (
        this.$refs.blog &&
        this.$refs.blog.options &&
        this.$refs.blog.options.page
      ) {
        this.$refs.blog.options.page = 1;
      }

      if (category !== null) {
        this.categories.push(category.slug);
      }
    },
  },
};
